export const CONSTANTS = { URL: "https://www.okaycarbon.com" }
